import React from 'react';
import { useForm } from 'react-hook-form';
import { IconCheck, IconX } from '@tabler/icons-react';
import type { ThemeData } from '../../../entities/theme';
import { DEFAULT_THEME } from '../../../entities/theme';
import { Button } from '../../../shared/ui/Button';
import { THEME_FORM_GROUPS } from '../model/types';

interface ThemeModalProps {
  initial?: ThemeData;
  onSave: (data: ThemeData) => Promise<void>;
  onClose: () => void;
}

const ThemeModal: React.FC<ThemeModalProps> = ({ initial, onSave, onClose }) => {
  const { register, handleSubmit, watch, setValue, formState: { isSubmitting } } = useForm<ThemeData>({
    defaultValues: { ...DEFAULT_THEME, ...initial },
  });

  const onSubmit = handleSubmit(async (data) => {
    await onSave(data);
    onClose();
  });

  return (
    <div className="mo open" onClick={onClose}>
      <div className="cm cm-create" style={{ maxWidth: 620 }} onClick={e => e.stopPropagation()}>
        <div className="cm-top">
          <div className="cm-ti">{initial ? 'Редактировать тему' : 'Новая тема'}</div>
          <div className="cm-sp" />
          <button className="cm-x" onClick={onClose} type="button">
            <IconX size={16} stroke={2} />
          </button>
        </div>

        <form className="cm-create-body" onSubmit={onSubmit} style={{ gap: 0 }}>
          <div className="adm-field" style={{ marginBottom: 20 }}>
            <label className="adm-label">Название <span className="adm-req">*</span></label>
            <div className="adm-input-wrap">
              <input
                className="adm-input"
                placeholder="Например: Тёмная тема"
                style={{ paddingLeft: 14 }}
                {...register('name', { required: true })}
              />
            </div>
          </div>

          {THEME_FORM_GROUPS.map(group => (
            <div key={group.label} style={{ marginBottom: 20 }}>
              <p className="sec">{group.label}</p>
              <div className="inf-grid">
                {group.fields.map(({ key, label, isColor }) => {
                  const value = watch(key as keyof ThemeData) as string;
                  return (
                    <div key={key} className="adm-field">
                      <label className="adm-label">{label}</label>
                      {isColor ? (
                        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                          <div className="adm-color-swatch" style={{ background: value }}>
                            <input
                              type="color"
                              className="adm-color-input"
                              value={value || '#000000'}
                              onChange={e => setValue(key as keyof ThemeData, e.target.value)}
                            />
                          </div>
                          <input
                            className="adm-input"
                            style={{ paddingLeft: 14, fontFamily: 'monospace', fontSize: 13 }}
                            {...register(key as keyof ThemeData)}
                          />
                        </div>
                      ) : (
                        <input
                          className="adm-input"
                          style={{ paddingLeft: 14, fontFamily: 'monospace', fontSize: 13 }}
                          {...register(key as keyof ThemeData)}
                        />
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}

          <div className="adm-form-actions">
            <Button variant="adm-cancel" type="button" onClick={onClose}>
              Отмена
            </Button>
            <Button variant="adm-save" type="submit" disabled={isSubmitting}>
              {isSubmitting ? <span className="adm-btn-spinner" /> : <IconCheck size={15} stroke={2.5} />}
              Сохранить
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export { ThemeModal };
